import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { REBelegart } from '@work4all/models/lib/Enums/REBelegart.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function InvoiceKindPicker<TMultiple extends boolean>(
  props: Props<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return Object.keys(REBelegart)
      .map((key) => {
        const id = REBelegart[key];

        return {
          id,
          name: t(`INVOICE_KINDS.${id}`),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
